import { Link } from "react-router-dom";
import { PageHero } from "@/components/PageHero";
import { SectionHeading } from "@/components/SectionHeading";
import { CTASection } from "@/components/CTASection";
import { CITIES } from "@/data/seoPages";
import { IMAGES } from "@/data/site";
import { MapPin } from "@phosphor-icons/react";
import { useSEO, breadcrumbLd, organizationLd } from "@/lib/seo";

export default function Locations() {
  useSEO({
    title: "Service Areas Across Canada | MRE Developments",
    description:
      "MRE Developments serves Calgary and region for construction, and offers branding, web, marketing and AI across every major city in Canada. Find your location.",
    path: "/locations",
    image: IMAGES.heroFallback,
    jsonLd: [
      organizationLd(),
      breadcrumbLd([{ name: "Home", path: "/" }, { name: "Locations", path: "/locations" }]),
      { "@context": "https://schema.org", "@type": "ItemList", itemListElement: CITIES.map((c, i) => ({ "@type": "ListItem", position: i + 1, name: c.name, url: `https://mredevelopments.com/locations/${c.slug}` })) },
    ],
  });

  const provinces = [...new Set(CITIES.map((c) => c.province))];

  return (
    <div data-testid="locations-index">
      <PageHero
        overline="Locations"
        title="Across Canada."
        intro="Construction in the Calgary region; branding, web, marketing and AI from coast to coast. Find your city."
        image={IMAGES.heroFallback}
        breadcrumb={[{ name: "Home", path: "/" }, { name: "Locations", path: "/locations" }]}
      />
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8 py-16 lg:py-20">
        {provinces.map((prov) => (
          <div key={prov} className="mb-12">
            <SectionHeading overline={CITIES.find((c) => c.province === prov)?.code} title={prov} />
            <div className="flex flex-wrap gap-3 mt-7">
              {CITIES.filter((c) => c.province === prov).map((c) => (
                <Link key={c.slug} to={`/locations/${c.slug}`} data-testid={`locations-link-${c.slug}`} className="font-mono-tech text-xs tracking-widest uppercase border border-border px-4 h-11 inline-flex items-center gap-2 hover:border-primary hover:text-primary transition-colors">
                  <MapPin size={14} /> {c.name}
                  {c.core && <span className="text-primary text-[9px]">●</span>}
                </Link>
              ))}
            </div>
          </div>
        ))}
        <p className="font-mono-tech text-[11px] tracking-widest uppercase text-muted-foreground">
          <span className="text-primary">●</span> Core construction service area
        </p>
      </div>
      <CTASection title="Find us in your city." />
    </div>
  );
}
